import {
    getLocal,
    setLocal
} from "@/store/local";

export const stored = {
    namespaced: true,
    state: () => {
        const {
            userInfo = {
                uid: -1
            }
        } = getLocal('stored', true)
        return {
            // 用户信息
            userInfo
        }
    },
    getters: {
        // 根据登录状态判断是否显示路由内容
        showRoutePage(state) {
            let uid = state.userInfo.uid
            return uid && uid > 0
        }
    },
    mutations: {
        setUserInfo(state, value) {
            state.userInfo = value
            setLocal('stored', state)
        }
    }
}
